import React, { useState, useRef } from "react";
import { CloudscapeJsonFormsStudio } from "@amzn/fin-tech-cloudscape-json-forms-studio";
import type { CloudscapeJsonSchema } from "@amzn/fin-tech-cloudscape-json-forms";
import { STUDIO_API_CONFIG, STUDIO_BROWSER_FOLDERS } from "./constants";
import { CUSTOM_RENDERERS, CUSTOM_FIELD_TYPES } from "./customRenderers";
import SaveSchemaModal from "./SaveSchemaModal";

const FormStudioView: React.FC = () => {
  const [saveModalVisible, setSaveModalVisible] = useState(false);
  const schemaRef = useRef<CloudscapeJsonSchema>({
    type: "object",
    properties: {},
  });

  return (
    <div>
      <CloudscapeJsonFormsStudio
        apiUrl={STUDIO_API_CONFIG.apiUrl}
        schemaApi={STUDIO_API_CONFIG.schemaApi}
        browserFolders={STUDIO_BROWSER_FOLDERS}
        onSave={() => setSaveModalVisible(true)}
        persistKey="nucleus-form-studio"
        customFieldTypes={CUSTOM_FIELD_TYPES}
        customRenderers={CUSTOM_RENDERERS}
        onSchemaChange={(schema) => {
          schemaRef.current = schema;
        }}
      />
      <SaveSchemaModal
        visible={saveModalVisible}
        onDismiss={() => setSaveModalVisible(false)}
        schemaRef={schemaRef}
      />
    </div>
  );
};

export default FormStudioView;
